import {Layout} from "@components";
import React from "react";
import styles from "./style.module.scss";
import {envUtil} from "@utils";
import {ScreenId, Svgs} from "@assets";

export default function Page() {
  const handleKakaoLogin = () => {
    const kakaoAuthUrl =
      `https://kauth.kakao.com/oauth/authorize` +
      `?client_id=${envUtil.KAKAO_KEY}` +
      `&redirect_uri=${encodeURIComponent(`${window.location.origin}${ScreenId.KAKAO_LOGIN_CALLBACK}`)}` +
      `&response_type=code`;

    window.location.href = kakaoAuthUrl;
  };

  return (
    <Layout>
      <div className={styles.container}>
        <div className={styles.title}>로그인</div>
        <div className={styles.subTitle}>
          광주하남카네기 CEO클럽 회원 전용 플랫폼으로
          <br />
          비회원은 이용이 제한됩니다.
        </div>
        <button onClick={handleKakaoLogin} className={styles.btn}>
          <Svgs.Kakao />
          카카오톡 로그인/회원가입
        </button>
      </div>
    </Layout>
  );
}
